import React, { useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { Link, useHistory } from "react-router-dom";
import { base_url, menus } from "../config";

const Header = (props, ref) => {
  const history = useHistory()

  const [menuToggleIcon, setMenuToggleIcon] = useState(<FaBars className="text-white" fontSize="20" />)

  const toggleMenu = () => {
    const menu = document.querySelector('nav')
    
    menu.classList.toggle('hidden')
    menu.classList.contains('hidden') ? setMenuToggleIcon(<FaBars className="text-white" fontSize="20" />) : setMenuToggleIcon(<FaTimes className="text-white" fontSize="20" />)
  }

  return (
    <header
      ref={ref}
      className="fixed w-screen px-5 md:px-32 py-4 bg-black flex flex-col md:flex-row justify-between items-center animation duration-200"
      style={{ zIndex: 1 }}
    >
      <div className="flex w-full md:w-max justify-between items-center">
        <div className="text-2xl font-medium text-primary">
          <Link to="/">akbarputra</Link>
        </div>
        <button type="button" className="block md:hidden menu-toggle" onClick={toggleMenu}>{menuToggleIcon}</button>
      </div>
      <nav className="hidden flex flex-col md:flex md:flex-row justify-around gap-3 md:gap-8 mt-5 md:mt-0">
        {menus.map((menu) => (
          <a
            key={menu.id}
            href={history.location.pathname !== '/' ? base_url+menu.url : menu.url}
            className="group font-light text-white"
          >
            {menu.title}
            <div className="indicator bg-transparent w-3/5 h-1 group-hover:bg-primary transition duration-200" />
          </a>
        ))}
      </nav>
    </header>
  );
};

export default React.forwardRef(Header);
